(() => {
  'use strict';
  if (window.agoCartDateGuard) return;
  const policy = window.agoCartBestBeforePolicy;
  if (!policy) return;
  let resolveReady;
  const ready = new Promise(resolve => { resolveReady=resolve; });
  const root = window.Shopify?.routes?.root || '/';
  const cartUrl = root + 'cart';
  const section = 'ago-cart-best-before-facts';
  const intentKey = 'ago.cart-date-return.v1';
  let facts = null, shown = null, busy = false, selectionAtStart = '', ownWrite = false;
  let copy = {}, activeWrites = new Set(), deliveryEdited = false;
  const val = selector => document.querySelector(selector)?.value || '';
  const selection = () => ['.umall-calander-postcode', '.umall-calander-calendar-date-hidden', '.umall-calander-delivery-time-select'].map(val).join('|');
  const date = () => val('.umall-calander-calendar-date-hidden');
  // Liquid has no documented cart.token. Bind the one server-facts read to Shopify's
  // browser Cart cookie; keep only its digest, never the token, in UI/session data.
  const cookie = () => document.cookie.split(';').map(value => value.trim()).find(value => value.startsWith('cart='))?.slice(5) || '';
  async function cartIdentity() {
    const token = cookie();
    if (!token) throw Error('Cart identity unavailable');
    const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(token));
    return [...new Uint8Array(digest)].map(value => value.toString(16).padStart(2, '0')).join('');
  }
  const $ = () => window.jQuery_T4NT || window.jQuery;
  const text = (key, count) => String(copy[key] || key).replace('[count]', String(count));
  // Availability arrives in the same Cart section as the date facts; no extra request.
  function review(current) {
    if (!current) return null;
    return policy.checkCartReview(current, date());
  }
  function parse(html) {
    const doc = typeof html === 'string' ? new DOMParser().parseFromString(html, 'text/html') : html;
    const nodes = doc.querySelectorAll('script[data-ago-cart-date-facts]');
    if (!nodes.length) throw Error('Missing current Cart date facts');
    const next = JSON.parse(nodes[nodes.length - 1].textContent);
    if (!Array.isArray(next.lines) || next.lines.length !== next.lineCount) throw Error('Incomplete Cart date facts');
    if (!next.complete || new Set(next.lines.map(line => line.id)).size !== next.lines.length
      || next.lines.some(line => !line.id || !line.variantId || !Number.isSafeInteger(line.quantity) || line.quantity < 1)
      || next.lines.reduce((sum, line) => sum + line.quantity, 0) !== next.totalQuantity) throw Error('Incomplete Cart facts');
    return next;
  }
  async function request(url, options = {}) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), options.method ? 10000 : 5000);
    try {
      const response = await fetch(url, { ...options, cache: 'no-store', credentials: 'same-origin', signal: controller.signal });
      if (!response.ok) throw Error('Cart request failed');
      return options.method ? response.json() : response.text();
    } finally { clearTimeout(timer); }
  }
  const refresh = async () => {
    const identity = await cartIdentity();
    const next = parse(await request(`${cartUrl}?section_id=${section}&_ago_check=${Date.now()}`));
    if (identity !== await cartIdentity()) throw Error('Cart changed during check');
    next.cartId = identity;
    facts = next;
    return next;
  };
  function lock() {
    if (busy || activeWrites.size) return false;
    busy = true; selectionAtStart = selection();
    document.documentElement.setAttribute('data-ago-cart-date-busy', '');
    return true;
  }
  function release() {
    busy = false;
    document.documentElement.removeAttribute('data-ago-cart-date-busy');
  }
  function panel() {
    const host = document.querySelector('.umall-calander-container');
    if (!host) return null;
    let node = host.querySelector('[data-ago-date-notice]');
    if (!node) {
      node = document.createElement('div'); node.dataset.agoDateNotice = ''; node.className = 'ago-cart-date-notice';
      node.setAttribute('role', 'status'); node.setAttribute('tabindex', '-1'); host.append(node);
    }
    return node;
  }
  function render(error, focus = false) {
    const node = panel(); if (!node) return;
    const result = review(facts);
    shown = result ? { facts, result, selection: selection() } : null;
    node.replaceChildren(); node.hidden = !error && (!result || result.status === 'pass');
    if (node.hidden) return;
    const add = (tag, value) => { const el = document.createElement(tag); el.textContent = value; node.append(el); return el; };
    const unknown = result?.issues.some(item => item.reason === 'unconfirmed');
    const mixedText = copy[unknown ? 'mixedUnconfirmed' : 'mixed'] || policy.cartMixedReviewMessage(result?.dateCheck);
    add('span', error || (result?.status === 'mixed' ? mixedText : result?.status === 'stock' ? text('stock') : result?.status === 'unavailable' ? text('unavailable') : text(unknown ? 'unconfirmed' : 'conflict')));
    const button = (label, action) => { const el = add('button', label); el.type = 'button'; el.onclick = action; return el; };
    if (!error && result?.issues.length) button(text(['stock', 'mixed'].includes(result.status) ? 'removeAll' : 'remove', result.issues.length), () => void remove());
    else button(text('retry'), () => void retry());
    if (focus) { node.scrollIntoView({ block: 'center', behavior: 'smooth' }); node.focus({preventScroll:true}); }
  }
  async function retry() {
    if (!lock()) return;
    try { await refresh(); render(); } catch (_) { render(text('unavailable'), true); }
    finally { release(); }
  }
  function remember() {
    try { sessionStorage.setItem(intentKey, JSON.stringify({ cartId: facts.cartId, selection: selection().split('|'), at: Date.now() })); } catch (_) {}
  }
  function savedReturn() {
    try {
      if (deliveryEdited || !facts?.cartId) return null;
      const saved = JSON.parse(sessionStorage.getItem(intentKey));
      const age = Date.now() - saved?.at;
      return saved && saved.cartId === facts.cartId && Number.isFinite(saved.at) && age >= 0 && age < 180000
        && Array.isArray(saved.selection) && saved.selection.length === 3
        && saved.selection.every(value => typeof value === 'string') && /^\d{4}$/.test(saved.selection[0]) ? saved.selection : null;
    } catch (_) { return null; }
  }
  function returning() {
    const saved = savedReturn();
    return saved && saved[0] === val('.umall-calander-postcode') ? saved : null;
  }
  // Install before async readiness: a shopper's edit, even one later erased, wins.
  function deliveryEdit(event) {
    const selector = event.type === 'click'
      ? '.umall-calander-cell:not(.umall-calander-disabled), .umall-calander-search-button'
      : '.umall-calander-postcode, .umall-calander-delivery-time-select';
    if (!event.target?.closest(selector)) return;
    deliveryEdited = true;
    try { sessionStorage.removeItem(intentKey); } catch (_) {}
  }
  ['input', 'change', 'click'].forEach(type => document.addEventListener(type, deliveryEdit, true));
  async function remove() {
    const approved = shown;
    if (!approved || approved.selection !== selection() || !lock()) return;
    try {
      const latest = await refresh();
      if (selection() !== selectionAtStart) { render(text('changed'), true); return; }
      const ids = policy.currentCartReviewRemovalIds(approved.facts, approved.result.stockIssues,
        approved.result.dateCheck?.status === 'conflict' ? approved.result.dateCheck : null, latest, date());
      if (!ids.length) { render(text('changed'), true); return; }
      const updates = Object.fromEntries(ids.map(id => [id, 0]));
      ownWrite = true;
      const response = await request(root+'cart/update.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ updates, sections:[section], sections_url:cartUrl }) });
      if (!Array.isArray(response.items) || response.items.some(item => ids.includes(item.key))) throw Error('Removal needs reconciliation');
      // Bundled facts must be valid. A missing section requires one read, never another mutation.
      try {
        const next = parse(response.sections?.[section] || '');
        next.cartId = await cartIdentity();
        if (next.cartId !== latest.cartId) throw Error('Cart changed');
        facts = next;
      } catch (_) { await refresh(); }
      remember();
      // This legacy Theme does not expose a reliable complete-Cart renderer. Reload its existing owner
      // once after an explicit removal so gift, coupons, totals and delivery are all rebuilt together.
      window.location.assign(cartUrl);
    } catch (_) {
      try { await refresh(); } catch (_) { facts = null; }
      render(text('removeError'), true);
    } finally { ownWrite = false; release(); }
  }
  window.agoCartDateGuard = {
    ready,
    isBusy: () => busy,
    release,
    selectionCurrent: () => selectionAtStart === selection(),
    preview: () => render(),
    restorePostcode() {
      const saved = savedReturn();
      const input = document.querySelector('.umall-calander-postcode');
      if (!saved || !input || input.disabled || input.value) return false;
      input.value = saved[0];
      return true;
    },
    restoreDate(fallback) {
      const saved = returning(); const jq=$();
      if (!saved || !jq) return fallback;
      const cell = [...document.querySelectorAll('.umall-calander-calendar-body .umall-calander-cell:not(.umall-calander-disabled)')].find(el => jq(el).data('date')?.format('DD-MM-YYYY') === saved[1]);
      return cell ? jq(cell).data('date') : null;
    },
    restoreTime(previous) { const saved=returning(); return saved && saved[1]===date() ? saved[2] : previous; },
    clearReturnIntent() { try { sessionStorage.removeItem(intentKey); } catch (_) {} },
    async checkForCheckout() {
      if (!lock()) return false;
      const started = performance.now();
      try {
        await refresh();
        if (selectionAtStart !== selection()) throw Error('Delivery changed');
        const result = review(facts); render(null, result?.status !== 'pass');
        if (result?.status !== 'pass') { release(); return false; }
        return true;
      } catch (_) { render(text('unavailable'), true); release(); return false; }
      finally { document.dispatchEvent(new CustomEvent('ago:cart-date-check', {detail:{durationMs:Math.round(performance.now()-started)}})); }
    },
  };
  async function boot() {
    try { copy=JSON.parse(document.getElementById('AgoCartDateCopy')?.textContent || '{}'); } catch (_) {}
    try { facts=parse(document); facts.cartId=await cartIdentity(); } catch (_) { facts=null; }
    render();
    const jq=$();
    jq?.(document).ajaxSend((_,xhr,settings) => { if (!ownWrite && /\/cart\/(?:add|change|update|clear)/.test(settings?.url||'')) activeWrites.add(xhr); }); // 2026-10-03 (Umall): settings?.url - Klaviyo onsite.js fires ajaxSend without settings, which threw here
    jq?.(document).ajaxComplete((_,xhr) => activeWrites.delete(xhr));
    new MutationObserver(changes => {
      let changed=false;
      for (const change of changes) for (const node of change.addedNodes) {
        if (node.nodeType===1 && (node.matches('script[data-ago-cart-date-facts]') || node.querySelector('script[data-ago-cart-date-facts]'))) {
          try { const next=parse(node.matches('script') ? node.parentNode : node); next.cartId=facts?.cartId || ''; facts=next; changed=true; } catch (_) {}
        }
      }
      if (changed && !busy) render();
    }).observe(document.body,{childList:true,subtree:true});
    const preventDuringCheck = event => {
      if (busy && event.target.closest('.mini_cart_actions, .cart_ac_remove, .cart_ac_edit, .umall-calander-container, .btn-checkout, .btn_checkout')) { event.preventDefault(); event.stopImmediatePropagation(); }
    };
    document.addEventListener('click',preventDuringCheck,true);
    document.addEventListener('keydown',preventDuringCheck,true);
    document.addEventListener('visibilitychange', () => { if (document.hidden) shown=null; });
    resolveReady();
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot,{once:true}); else boot();
})();
